module.exports = __webpack_public_path__ + "img/item2.5dbcf6d5.png";